import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useTranslation } from '../hooks/useTranslation';
import './Header.css';

const Header = () => {
  const publicUrl = process.env.PUBLIC_URL || '';
  const { getItemCount } = useCart();
  const { t } = useTranslation();

  return (
    <header className="header">
      <div className="container header-content">
        <Link to="/" className="logo">
          <img src={`${publicUrl}/logomuseo.png`} alt="Museo Stibbert" className="logo-image" />
        </Link>

        <nav className="nav">
          <Link to="/" className="nav-link">{t('header.home')}</Link>
          <a href="https://www.museostibbert.it" target="_blank" rel="noopener noreferrer" className="nav-link">
            {t('header.museum_site')}
          </a>
          <Link to="/carrello" className="nav-link cart-link">
            <i className="fas fa-shopping-cart cart-icon"></i>
            {getItemCount() > 0 && (
              <span className="cart-badge">{getItemCount()}</span>
            )}
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;

